import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GrievanceDashboardRoutingModule } from './grievance-dashboard-routing.module';

import { GrievanceLandingPageComponent } from './grievance-landing-page/grievance-landing-page.component';
import { GrievanceLinkComponent } from './grievance-link/grievance-link.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { GrievanceHeaderComponent } from './grievance-header/grievance-header.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { GrievanceUser1Component } from './grievance-user1/grievance-user1.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { AgGridModule } from 'ag-grid-angular';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import more from 'highcharts/highcharts-more.src';
import solidGauge from 'highcharts/modules/solid-gauge.src';
import { SidebarComponent } from './sidebar/sidebar.component';
import { GrievanceReportComponent } from './grievance-report/grievance-report.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from "ag-grid-enterprise";
import { environment } from 'src/environments/environment';

import { Grievanceuser2DashboardComponent } from './grievanceuser2-dashboard/grievanceuser2-dashboard.component';
import { TicketDetailsUser2Component } from './ticket-details-user2/ticket-details-user2.component';
import { NgxEditorModule } from "ngx-editor";
import { GrievanceAdminComponent } from './grievance-admin/grievance-admin.component';
import { TicketAdminComponent } from './ticket-admin/ticket-admin.component';
import { GrievanceSuperAdminComponent } from './grievance-super-admin/grievance-super-admin.component';
import { TicketSuperAdminComponent } from './ticket-super-admin/ticket-super-admin.component';
import { SuperAdminFilterDialogComponent } from './super-admin-filter-dialog/super-admin-filter-dialog.component';
import { EmployeeGrievanceApplicationComponent } from './employee-grievance-application/employee-grievance-application.component';

export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [more, solidGauge];
}

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(environment.ag_grid_key);

@NgModule({
  declarations: [
    GrievanceLandingPageComponent,
    GrievanceLinkComponent,
    GrievanceHeaderComponent,
    TicketDetailsComponent,
    GrievanceUser1Component,
    SidebarComponent,
    GrievanceReportComponent,
    EmployeeGrievanceApplicationComponent,

    Grievanceuser2DashboardComponent,
    TicketDetailsUser2Component,
    GrievanceAdminComponent,
    TicketAdminComponent,
    GrievanceSuperAdminComponent,
    TicketSuperAdminComponent,
    SuperAdminFilterDialogComponent
  ],
  imports: [
    CommonModule,
    HighchartsChartModule,
    GrievanceDashboardRoutingModule,
    AcademicFormModule,
    FormsModule,
    ReactiveFormsModule,
     AgGridModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    ChartModule,
    MatTooltipModule,
    NgxEditorModule
  ],

    providers: [
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules } 
  ]
})
export class GrievanceDashboardModule { }
